import { Injectable } from '@angular/core';
import {
  ApiService,
  StorageService,
  StorageType,
  TimerService,
  UserBalance
} from '@rct/lynx-lobbies-shared-lib';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { LYNX_STORAGE_KEYS } from '../constants/lynx-storage-keys.constant';
import { LynxTokenConstant } from '../constants/token-constant';
import { User } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class LynxUserService {
  private balanceSubject: BehaviorSubject<number | null> = new BehaviorSubject(
    null
  );

  constructor(
    private apiService: ApiService,
    private timerService: TimerService,
    private storageService: StorageService
  ) {}

  get userName(): string {
    const userObj = this.storageService.get(
      LYNX_STORAGE_KEYS.user,
      StorageType.Session
    );
    return userObj ? userObj.userName : '';
  }

  get user(): User {
    return (
      this.storageService.get(LYNX_STORAGE_KEYS.user, StorageType.Session) ||
      new User()
    );
  }

  get balance$(): Observable<number | null> {
    return this.balanceSubject.asObservable();
  }

  initBalanceTimer(): void {
    this.timerService.start({
      action: this.getUserBalance.bind(this),
      startInSeconds: 0,
      repeatInSeconds: LynxTokenConstant.balanceRefreshFrequency
    });
  }

  getUserBalance(): Observable<UserBalance> {
    return this.apiService.getUserBalance$().pipe(
      tap((response: UserBalance) => {
        this.balanceSubject.next(response.balance);
      }),
      catchError((error) => {
        this.balanceSubject.next(null);
        return throwError(error);
      })
    );
  }
}
